export class AppConstants {
  static userBaseUrl = process.env.REACT_APP_USER_BASE_URL;
  static formBaseUrl = process.env.REACT_APP_FORM_BASE_URL;
  static eventBaseUrl = process.env.REACT_APP_EVENT_BASE_URL;
  static authBaseUrl = process.env.REACT_APP_AUTH_BASE_URL;
  static imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  static enquiryBaseUrl = process.env.REACT_APP_ENQUIRY_BASE_URL;
  static ecounsellingBaseUrl = process.env.REACT_APP_ECOUNSELLING_BASE_URL;
}
